import { render, staticRenderFns } from "./CaseGroupMedical.vue?vue&type=template&id=1cff5db0"
import script from "./CaseGroupMedical.vue?vue&type=script&lang=js"
export * from "./CaseGroupMedical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports